/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { MDX as Mdx, Image } from 'contentbricks'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { ChapterNavigation } from 'components/ChapterNavigation'
import { chapters } from './data'
// TODO Set the correct article ID here
const ARTICLE_ID = '30091517'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={11} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical  segment headerSegement'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Wie die Naturwissen<span>-</span>schaften den Himmel leer räumten
            </div>
          </h1>
        </div>
      </header>

      <div className='ui text container'>
        <div className='subheader'>
          Die Naturwissenschaften haben den Himmel ausgeräumt. Aber das
          Bedürfnis nach Spiritualität bleibt. Sieben Schritte zu einem
          aufgeklärten Glauben mit dem Philosophen Jürgen Habermas.
        </div>
        <div className='ta author'>Res Strehle und Felix Schaad</div>
        <Mdx file={require('text/intro.mdx')} />
      </div>
      <ChapterNavigation content={chapters} />

      {chapters.map((chapters, i) => {
        return (
          <React.Fragment key={i}>
            <div className='ui text container illu ' id={chapters.id}>
              <Image
                className='cbImage illu'
                file={require('images/' + chapters.illu)}
              />
              <h3>{chapters.name}</h3>
              <Mdx file={require('text/' + chapters.id + '.mdx')} />
            </div>
          </React.Fragment>
        )
      })}

      <div className='ui vertical segment '>
        <div className='ui text container biobox'>
          <Mdx file={require('text/book.mdx')} />
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={['Wie informativ war der Beitrag?']}
        credits={[
          ['Text', 'Res Strehle'],
          ['Illustrationen', 'Felix Schaad'],
          ['Umsetzung', 'Sebastian Broschinski']
        ]}
      />
    </div>
  )
}
